// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const LabelTag = ({ label }: { label: string }) => {
  const { t } = useTranslation();
  return (
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.grey[800],
        color: 'white',
        borderRadius: '4px',
        px: '8px',
        height: '28px',
        width: 'fit-content',
      }}
      variant="subtitle3"
      fontWeight={600}
    >
      {t(label)}
    </Typography>
  );
};
